exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".document-view {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column; }\n\n.deleted-notification {\n  margin-left: auto;\n  margin-right: auto; }\n", ""]);

// exports
